import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Select, MenuItem, FormControl } from '@mui/material'

const states = [
  {
    name: 'Connecticut',
    imageSrc: 'state-logo-connecticut.png',
    stateResourcesURL: 'https://portal.ct.gov/dcp/medical-marijuana-program/medical-marijuana-program?language=en_US',
    isCertificated: true,
    providers: [
      // {
      //   name: 'Elevate Holistics',
      //   imageSrc: 'EH_Long_logo.png',
      //   newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
      //   renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
      // },
      {
        name: 'EZ Medcard',
        imageSrc: 'ezmedcard.png',
        newPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
        renewingPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
        promocodeNew: 'Use promo code bennabix129',
        promocodeRenew: 'Use promo code bennabix89',
      },
      // {
      //   name: 'NuggMD',
      //   imageSrc: 'NuggMD.png',
      //   newPatientURL: 'https://www.nuggmd.com/',
      //   renewingPatientURL: 'https://www.nuggmd.com/',
      // },
    ]
   },
 {
  name: 'Delaware',
  imageSrc: 'state-logo-delaware.png',
  stateResourcesURL: 'https://dhss.delaware.gov/dhss/dph/hsp/medmarhome.html',
  isCertificated: true,
  providers: [
  //  {
  //   name: 'Elevate Holistics',
  //   imageSrc: 'EH_Long_logo.png',
  //   newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //   renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //  },
   {
    name: 'CMed',
    imageSrc: 'cmed.png',
    newPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=DE&timezone=EST&skip=yes&visit_type_id=2427&utm_source=bennabixpilot',
    renewingPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=DE&timezone=EST&skip=yes&visit_type_id=2428&utm_source=bennabixpilot',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixde',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixde',
    promocodeNew: 'Use promo code BENNABIX40',
    promocodeRenew: 'Use promo code BENNABIX40',
   }
  ]
 },
 {
  name: 'Maine',
  imageSrc: 'state-logo-maine.png',
  stateResourcesURL: 'https://www.maine.gov/dafs/ocp/medical-use/applications-forms/registryidentificationcard-instructions',
  isCertificated: true,
  providers: [
  //  {
  //   name: 'Elevate Holistics',
  //   imageSrc: 'EH_Long_logo.png',
  //   newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //   renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //  },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixme',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixme',
    promocodeNew: 'Use promo code BENNABIX40',
    promocodeRenew: 'Use promo code BENNABIX40',
   }
  ]
 },
 {
  name: 'Maryland',
  imageSrc: 'state-logo-maryland.png',
  stateResourcesURL: 'https://cannabis.maryland.gov/Pages/Medical_Cannabis.aspx',
  isCertificated: true,
  providers: [
   {
    name: 'Elevate Holistics',
    imageSrc: 'EH_Long_logo.png',
    newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
    renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixmd',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixmd',
    promocodeNew: 'Use promo code BENNABIX40',
    promocodeRenew: 'Use promo code BENNABIX40',
   }
  ]
 },
 {
  name: 'Massachusetts',
  imageSrc: 'state-logo-massachusetts.png',
  stateResourcesURL: 'https://masscannabiscontrol.com/',
  isCertificated: true,
  providers: [
  //  {
  //   name: 'Elevate Holistics',
  //   imageSrc: 'EH_Long_logo.png',
  //   newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //   renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
  //  },
   {
    name: 'CMed',
    imageSrc: 'cmed.png',
    newPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=MA&timezone=EST&skip=yes&visit_type_id=2431&utm_source=bennabixpilot',
    renewingPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=MA&timezone=EST&skip=yes&visit_type_id=2432&utm_source=bennabixpilot',
   },
   {
    name: 'EZ Medcard',
    imageSrc: 'ezmedcard.png',
    newPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
    renewingPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
    promocodeNew: 'Use promo code bennabix129',
    promocodeRenew: 'Use promo code bennabix89',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixma',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixma',
    promocodeNew: 'Use promo code BENNABIX40',
    promocodeRenew: 'Use promo code BENNABIX40',
   }
  ]
 },
 {
  name: 'New Jersey',
  imageSrc: 'state-logo-new-jersey.png',
  stateResourcesURL: 'https://www.nj.gov/cannabis/medicinalcannabis/',
  isCertificated: true,
  providers: [
   {
    name: 'Elevate Holistics',
    imageSrc: 'EH_Long_logo.png',
    newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
    renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
   },
   {
    name: 'CMed',
    imageSrc: 'cmed.png',
    newPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=NJ&timezone=EST&skip=yes&visit_type_id=1690',
    renewingPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=NJ&timezone=EST&skip=yes&visit_type_id=1691',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixnj25',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixnj25',
    promocodeNew: 'Use promo code BENNABIX100',
    promocodeRenew: 'Use promo code BENNABIX100',
   }
  ]
 },
 {
  name: 'New Mexico',
  imageSrc: 'state-logo-new-mexico.png',
  stateResourcesURL: 'https://www.nmhealth.org/about/mcp/svcs/',
  isCertificated: true,
  providers: [
   {
    name: 'Elevate Holistics',
    imageSrc: 'EH_Long_logo.png',
    newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
    renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixnm',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixnm',
    promocodeNew: 'Use promo code BENNABIX40',
    promocodeRenew: 'Use promo code BENNABIX40',
   }
  ]
 },
 {
  name: 'New York',
  imageSrc: 'state-logo-new-york.png',
  stateResourcesURL: 'https://cannabis.ny.gov/patients',
  isCertificated: true,
  providers: [
   {
    name: 'Elevate Holistics',
    imageSrc: 'EH_Long_logo.png',
    newPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
    renewingPatientURL: 'https://app2.elevate-holistics.com/elevate/customer/partner/bennabix',
   },
   {
    name: 'CMed',
    imageSrc: 'cmed.png',
    newPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=NY&timezone=EST&skip=yes&visit_type_id=2429&utm_source=bennabixpilot',
    renewingPatientURL:
     'https://cannacaredocs.videovisitmd.com/f/vshop-schedule?state=NY&timezone=EST&skip=yes&visit_type_id=2430',
   },
   {
    name: 'EZ Medcard',
    imageSrc: 'ezmedcard.png',
    newPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
    renewingPatientURL: 'https://ezmedcard.com/?utm_source=Bennabix&utm_medium=email&utm_campaign=partnership',
    promocodeNew: 'Use promo code bennabix129',
    promocodeRenew: 'Use promo code bennabix89',
   },
   {
    name: 'NuggMD',
    imageSrc: 'NuggMD.png',
    newPatientURL: 'https://www.nuggmd.com/bennabixny',
    renewingPatientURL: 'https://www.nuggmd.com/bennabixny',
    promocodeNew: 'Use promo code BENNABIX60',
    promocodeRenew: 'Use promo code BENNABIX60',
   }
  ]
 },
]

const MembershipCard = () => {
 const [selectedState, setSelectedState] = useState(null)
 const isMobile = window.innerWidth <= 767

 return (
  <React.Fragment>
   <Helmet>
    <title>
     Find a Physician | Bennabix: Medical Cannabis Discounts & Education
    </title>
    <meta
     name="description"
     content="New Jersey residents can find a provider, here, through the New Jersey Cannabis Regulatory Commission"
    />
   </Helmet>
   <div className="sectionWrap physicianTemplate">
    <img
     src={require('../assets/images/graphic-01.png')}
     alt=""
     className="backgroundSource"
    />
    <div className="sectionContainer" style={{ minHeight: '500px' }}>
     <div>
      <div
       style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        padding: '50px',
       }}
      >
       <span style={{ fontSize: '1.25rem', fontWeight: '500' }}>
        Speak with a medical cannabis expert today!
       </span>
       <p>
        We have secured a discount on medical evaluations for your medical
        cannabis card through our affiliates. Additional services and prices may vary so be sure to check out the options available to you.
       </p>
       <p>
        Select your state to see what options you have and book your appointment online.
       </p>
       <div
        className="graphic"
        style={{
         display: 'grid',
         gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
         gap: isMobile ? '40px' : '60px',
         justifyItems: 'center',
         alignItems: 'center',
         padding: '40px 25px',
        }}
       >
        <img
         src={require('../assets/images/affiliates/cmed.png')}
         alt=""
         style={{ maxWidth: isMobile ? '100%' : '60%', height: 'auto' }}
        />
        <img
         src={require('../assets/images/affiliates/EH_Long_logo.png')}
         alt="Elevate Holistics"
         style={{ maxWidth: isMobile ? '100%' : '60%', height: 'auto' }}
        />
        <img
         src={require('../assets/images/affiliates/NuggMD.png')}
         alt=""
         style={{ maxWidth: isMobile ? '100%' : '60%', height: 'auto' }}
        />
        <img
         src={require('../assets/images/affiliates/ezmedcard.png')}
         alt=""
         style={{ maxWidth: isMobile ? '100%' : '60%', height: 'auto' }}
        />
       </div>
      </div>
      <div>
       <div style={{ padding: isMobile ? '0 16px' : '0', marginBottom: '20px' }}>
         <FormControl fullWidth>
           <Select
             value={selectedState?.name || ''}
             onChange={(e) => {
               const state = states.find(s => s.name === e.target.value)
               setSelectedState(state)
             }}
             displayEmpty
             sx={{
               backgroundColor: 'white',
               color: '#0A670AFF',
               fontSize: '1.1rem',
               minHeight: '50px',
               '& .MuiOutlinedInput-notchedOutline': {
                 borderColor: '#dddcdb',
               },
               '&:hover .MuiOutlinedInput-notchedOutline': {
                 borderColor: '#0A670AFF',
               },
               '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                 borderColor: '#0A670AFF',
               },
             }}
           >
             <MenuItem value="" disabled>
               Select a State
             </MenuItem>
             {states.map((state, index) => (
               <MenuItem key={index} value={state.name}>
                 {state.name}
               </MenuItem>
             ))}
           </Select>
         </FormControl>
       </div>
       {selectedState ? (
         <div>
           <div style={{ padding: isMobile ? '0 16px' : '0' }}>
             <div
               style={{
                 backgroundColor: '#dddcdb',
                 height: '1px',
                 width: '100%',
               }}
             />
           </div>
           {selectedState.isCertificated === false ? (
             <div style={{ paddingBottom: '25px' }}>
               <div className="stateListContent">
                 <div
                   style={{
                     display: 'grid',
                     gridTemplateColumns: isMobile ? '1fr' : '1fr 200px',
                     gap: '30px',
                     width: '100%',
                     padding: isMobile ? '20px 70px' : '25px 32px',
                   }}
                 >
                   <div>
                     <div
                       style={{
                         textAlign: 'center',
                         fontSize: '1.25rem',
                         fontWeight: '600',
                       }}
                     >
                       We are working to secure a certification partner, please check
                       back.
                     </div>
                   </div>
                   <div style={{ 
                     display: 'flex', 
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     gap: '20px'
                   }}>
                     <img
                       src={require(`../assets/images/${selectedState.imageSrc}`)}
                       alt=""
                       style={{
                         width: isMobile ? '50%' : '80%',
                       }}
                     />
                     <a
                       rel="noreferrer"
                       target="_blank"
                       href={selectedState.stateResourcesURL}
                     >
                       <i className="fa fa-angle-right" aria-hidden="true"></i> State
                       Resources
                     </a>
                   </div>
                 </div>
               </div>
             </div>
           ) : (
             <div style={{ paddingBottom: '25px' }}>
               <div className="stateListContent">
                 <div
                   style={{
                     display: 'grid',
                     gridTemplateColumns: isMobile ? '1fr' : '1fr 200px',
                     gap: '30px',
                     width: '100%',
                     padding: isMobile ? '20px 70px' : '25px 32px',
                   }}
                 >
                   <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                     {selectedState.providers.map((provider, index) => (
                       <div
                         key={index}
                         style={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           gap: '20px',
                         }}
                       >
                         <img 
                           src={require(`../assets/images/affiliates/${provider.imageSrc}`)} 
                           alt="" 
                           style={{
                             maxWidth: '200px',
                             height: 'auto'
                           }}
                         />
                         <div
                           style={{
                             display: 'flex',
                             flexDirection: 'row',
                             alignItems: 'flex-start',
                             gap: '40px',
                           }}
                         >
                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '120px' }}>
                             <a
                               rel="noreferrer"
                               target="_blank"
                               href={provider.newPatientURL}
                               style={{ fontSize: '1rem' }}
                             >
                               <i className="fa fa-angle-right" aria-hidden="true"></i>
                               New Patient
                             </a>
                             {provider.promocodeNew ? (
                               <span style={{
                                 background: '#e0f7fa',
                                 color: '#0A670A',
                                 borderRadius: '6px',
                                 padding: '2px 8px',
                                 fontSize: '0.85rem',
                                 fontWeight: 500,
                                 display: 'inline-block',
                                 marginTop: '6px',
                                 textAlign: 'center',
                                 minWidth: '80px',
                               }}>{provider.promocodeNew}</span>
                             ) : (
                               <span style={{ minWidth: '80px', display: 'inline-block', marginTop: '6px' }}></span>
                             )}
                           </div>
                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '120px' }}>
                             <a
                               rel="noreferrer"
                               target="_blank"
                               href={provider.renewingPatientURL}
                               style={{ fontSize: '1rem' }}
                             >
                               <i className="fa fa-angle-right" aria-hidden="true"></i>
                               Renewing Patient
                             </a>
                             {provider.promocodeRenew ? (
                               <span style={{
                                 background: '#e0f7fa',
                                 color: '#0A670A',
                                 borderRadius: '6px',
                                 padding: '2px 8px',
                                 fontSize: '0.85rem',
                                 fontWeight: 500,
                                 display: 'inline-block',
                                 marginTop: '6px',
                                 textAlign: 'center',
                                 minWidth: '80px',
                               }}>{provider.promocodeRenew}</span>
                             ) : (
                               <span style={{ minWidth: '80px', display: 'inline-block', marginTop: '6px' }}></span>
                             )}
                           </div>
                         </div>
                       </div>
                     ))}
                   </div>
                   <div style={{ 
                     display: 'flex', 
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     gap: '20px'
                   }}>
                     <img
                       src={require(`../assets/images/${selectedState.imageSrc}`)}
                       alt=""
                       style={{
                         width: isMobile ? '50%' : '80%',
                       }}
                     />
                     <a
                       rel="noreferrer"
                       target="_blank"
                       href={selectedState.stateResourcesURL}
                     >
                       <i className="fa fa-angle-right" aria-hidden="true"></i> State
                       Resources
                     </a>
                   </div>
                 </div>
               </div>
             </div>
           )}
         </div>
       ) : (
         <div style={{ 
           padding: '100px 0',
           textAlign: 'center',
           color: '#666',
           fontSize: '1.1rem'
         }}>
           Please select a state to view available providers
         </div>
       )}
      </div>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}

export default MembershipCard
